<template>
    <div class="midblock padding15 font14 shadow marginbottom10 tform">
        <div class="marginbottom10">
            <p>
                Ben je al een
                <a href="/vip-club" target="_blank"
                    >CruiseReizen.nl VIP Club<sup>©</sup> Member</a
                >
                of lid van onze
                <a href="/nieuwsbrief" target="_blank">Nieuwsbrief</a> met leuke
                aanbiedingen en voordelen?<br />

                Voer hieronder je VIP Club<sup>©</sup> Member nummer of
                kortingscode in en wij berekenen direct je korting.
            </p>
            <div class="clear height5"></div>

            <span
                class="rood"
                v-if="discount.retrieved && discount.type === 'notFound'"
            >
                Deze korting kunnen we helaas niet terugvinden, neem
                <a href="tel:0107200500" style="color: inherit">contact</a>
                op met onze klantenservice.
            </span>
            <div class="clear height5"></div>

            <div class="floatleft width40 lineheight30">
                VIP Club<sup>©</sup> nummer of kortingscode:
            </div>
            <div class="floatleft width30">
                <input
                    v-model="discount.discountCode"
                    type="text"
                    size="10"
                    id="testDiscountCodeInput"
                    class="width100 requiredfield"
                />
            </div>

            <div class="floatleft width25">
                <button
                    v-if="
                        discount.type !== 'theme' && cruise.discount_level > 0
                    "
                    v-on:click="discountCommitAndReset"
                    class="floatright btn btn-success btn-addon width80 font12 bold uppercase tcenter margin20"
                >
                    Korting herstellen
                </button>
                <button
                    v-else=""
                    v-on:click="$emit('getDiscount-click')"
                    class="floatright btn btn-success btn-addon width80 font12 bold uppercase tcenter margin20"
                    id="testBerekenKortingButton"
                >
                    Bereken Korting
                </button>
            </div>
            <div class="clear height5"></div>

            <div>
                <div
                    class="floatleft width100 "
                    v-if="discount.retrieved && discount.level === null"
                >
                    <span class="rood">
                        Deze korting kunnen we helaas niet terugvinden, neem
                        alsjeblieft
                        <a href="tel:0107200500" style="color: inherit"
                            >contact</a
                        >
                        met ons op.
                    </span>
                </div>
            </div>
            <div class="clearfix"></div>
        </div>

        <input type="hidden" id="testDiscountVIPName" :value="discount.name" />
        <input type="hidden" id="testDiscountLevel" :value="discount.level" />

        <div v-if="discount.retrieved && discount.level > 0">
            <div class="floatleft width40">
                <img :src="discount.img_url" />
            </div>
            <div class="floatleft width60">
                <div
                    v-if="discount.type == 'theme'"
                    class="font20 marginbottom10"
                >
                    Op deze cruise krijg je vanzelf al
                    <b>{{ discount.description }}</b>
                </div>

                <div v-if="discount.type == 'theme'" class="marginbottom10">
                    Wil je liever gebruik maken van de VIP Club of Nieuwsbrief
                    korting, voer deze dan hierboven in.
                </div>

                <div
                    v-if="discount.type == 'vipClub'"
                    class="font20 marginbottom10"
                >
                    Gefeliciteerd, je bent <b>{{ discount.name }} Member</b>.
                </div>

                <div
                    v-if="discount.type !== 'theme' && cruise.discount_level"
                    class="marginbottom10"
                >
                    Wil je liever de originele korting herstellen? klik dan op
                    korting herstellen.
                </div>

                <div v-if="discount.level >= 0">
                    <div>
                        <img
                            :src="discount.starIconURL"
                            class="floatleft marginright5"
                            height="17"
                        />
                        Geen reserveringskosten
                    </div>
                    <div>
                        <img
                            :src="discount.starIconURL"
                            class="floatleft marginright5"
                            height="17"
                        />
                        Geen administratiekosten
                    </div>
                    <div>
                        <img
                            :src="discount.starIconURL"
                            class="floatleft marginright5"
                            height="17"
                        />
                        Geen transactiekosten
                        <span class="font11">(AMEX uitgezonderd)</span>
                    </div>
                </div>

                <div v-if="discount.vluchtKorting > 0">
                    <div>
                        <font-awesome-icon
                            icon="plane"
                            class="marginright5"
                            :style="{ color: discount.color_html }"
                        />
                        Korting op je vluchten: &euro;
                        {{ roundPrice(discount.vluchtKorting) }}
                    </div>
                </div>

                <div v-if="discount.transferKorting > 0">
                    <div>
                        <font-awesome-icon
                            icon="bus"
                            class="marginright5"
                            :style="{ color: discount.color_html }"
                        />
                        Korting op je transfers: &euro;
                        {{ roundPrice(discount.transferKorting) }}
                    </div>
                </div>

                <div v-if="discount.totaalKorting > 0">
                    <div>
                        <font-awesome-icon
                            icon="grin"
                            class="marginright5"
                            :style="{ color: discount.color_html }"
                        />
                        Korting op je cruise met vluchten: &euro;
                        {{ roundPrice(discount.totaalKorting) }}
                    </div>
                </div>
            </div>
        </div>
        <div class="clearfix"></div>
    </div>
</template>

<script>
export default {
    name: 'Discount',
    props: {
        discount: Object,
        roundPrice: Function,
        cruise: Object,
    },
    methods: {
        discountCommitAndReset: function() {
            this.discount.discountCode = ''
            this.emit('getDiscount-click')
        },
    },
}
</script>

<style scoped>
@media screen and (max-width: 1024px) {
    .width40,
    .width80,
    .width25,
    .width30,
    .width60 {
        width: 100% !important;
        margin: 5px auto;
    }
    .width30 {
        margin-bottom: 15px;
    }
}
</style>
